import React, { ChangeEvent } from 'react';
import { Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Tooltip } from '@mui/material';
import { SearchTopic, SearchTopics } from '../../enum/SearchTopics';

interface ChatPageRadioButtonsProps {
  selectedOption: SearchTopic;
  setSelectedOption: (option: SearchTopic) => void;
}

const ChatPageRadioButtons: React.FC<ChatPageRadioButtonsProps> = ({ selectedOption, setSelectedOption }) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value as SearchTopic);
  };

  return (
    <Box
      sx={{
        paddingX: 2,
        paddingY: 1,
        borderRadius: '16px',
        boxShadow: 1,
        border: (theme) => `2px solid ${theme.palette.primary.main}`,
        marginTop: '-5px',
        marginBottom: '5px',
      }}
    >
      <FormControl component={'fieldset'} sx={{ width: '100%', mt: 0 }}>
        <RadioGroup value={selectedOption} onChange={handleChange}>
          <Grid container>
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <FormControlLabel
                value={SearchTopics.MaterialSearch}
                control={<Radio size={'small'} />}
                label="I have a material question."
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <Tooltip title={window.REACT_APP_ENABLE_PRODUCT ? '' : 'Products - Under Development/Coming Soon'}>
                <FormControlLabel
                  value={SearchTopics.ProductSearch}
                  control={<Radio size={'small'} />}
                  label="I have a product question."
                  disabled={!window.REACT_APP_ENABLE_PRODUCT}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default ChatPageRadioButtons;
